import { useField } from "formik";

import {
  InputWrapperProps,
  InputWrapper,
} from "../components/inputs/_assets/input-wrapper/InputWrapper";
import {
  TextField,
  TextFieldProps,
} from "../components/inputs/text-field/TextField";

interface Props<K>
  extends Omit<TextFieldProps, "onChange">,
    Omit<InputWrapperProps, "children"> {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID: string;
  onChange?: (value: K) => void;
  isDisabled?: boolean;
  isNullable?: boolean;
  placeholder?: string;
}

export function TextInputFormikField<
  T,
  K = T extends true ? string | null : string,
>({
  span = "auto",
  testID = "text-input",
  isNullable,
  name,
  label,
  info,
  isDisabled,
  isRequired,
  placeholder,
  description,
  clearable,
  onChange,
  ...textFieldRest
}: Props<K>) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <TextField
        {...textFieldRest}
        value={field.value ?? ""}
        name={name}
        label={label}
        isInvalid={Boolean(meta.touched && meta.error)}
        errors={meta.touched ? meta.error : undefined}
        onChange={(param) => {
          const value = (isNullable && param === "" ? null : param) as K;
          helpers.setValue(value);
          onChange?.(value);
        }}
        onBlur={() => helpers.setTouched(true)}
        isRequired={isRequired}
        testID={testID}
        isDisabled={isDisabled}
        description={description}
        info={info}
        placeholder={placeholder}
        clearable={clearable}
      />
    </InputWrapper>
  );
}
